<div class="liked-users-dialog">
  <div class="liked-users-dialog dialog">
    <div class="liked-users-dialog-header dialog-header">
      <span><h5>{{data.isPost?'Post liked by':'Comment liked by'}}</h5></span>
      <span class="liked-users-dialog-header-close dialog-close" (click)="close()" (keypress)="close()">
        <img alt="close" [src]="'images/close.svg' | assetUrl" class="black-icon cursor-pointer" draggable="false">
      </span>
    </div>
    <mat-dialog-content class="liked-users-dialog-content dialog-content">
      @for (user of data.users; track user) {
        <p class="liked-users-dialog-content-header">
          <span class="cursor-pointer">
            <!-- <img
            [src]="user.profilePictureUrl"
            alt="user icon"
            class="user-img icon-mr-5"
            /> -->
            <app-user-thumb-nail [userEmail]="user.name" class="user-img icon-mr-5"></app-user-thumb-nail>
          </span>
          <span class="user-name">{{user.name}} {{user.atMention}}</span></p>
        }
      </mat-dialog-content>
    </div>
